(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-film"] && !Shopify.designMode) return;
  try {
    
  class OrnayaAboutFilm extends HTMLElement {
    connectedCallback(){
      this.frame = this.querySelector('[data-frame]');
      this.querySelector('[data-play]').addEventListener('click', () => this.play());
    }
    play(){
      const url = (this.dataset.video || '').trim();
      if(!url){ return; }
      let embed = '';
      const yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w-]+)/);
      const vm = url.match(/vimeo\.com\/(\d+)/);
      if(yt){ embed = '<iframe src="https://www.youtube.com/embed/'+yt[1]+'?autoplay=1&rel=0" allow="autoplay; fullscreen" allowfullscreen></iframe>'; }
      else if(vm){ embed = '<iframe src="https://player.vimeo.com/video/'+vm[1]+'?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>'; }
      else { embed = '<video src="'+url+'" autoplay controls playsinline></video>'; }
      this.frame.innerHTML = embed;
    }
  }
  if(!customElements.get('ornaya-about-film')) customElements.define('ornaya-about-film', OrnayaAboutFilm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-founder"] && !Shopify.designMode) return;
  try {
    
  class OrnayaParallax extends HTMLElement {
    connectedCallback(){ if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; this.inner=this.querySelector('img,.afo__ph')||this.firstElementChild; this.range=parseFloat(this.dataset.range||'30'); this.onScroll=this.onScroll.bind(this); window.addEventListener('scroll',this.onScroll,{passive:true}); this.onScroll(); }
    disconnectedCallback(){ window.removeEventListener('scroll',this.onScroll); }
    onScroll(){ const r=this.getBoundingClientRect(); const w=window.innerHeight; const p=(w-r.top)/(r.height+w); const y=(-this.range+p*this.range*2); if(this.inner) this.inner.style.transform='translate3d(0,'+y.toFixed(1)+'px,0)'; }
  }
  if(!customElements.get('ornaya-parallax')) customElements.define('ornaya-parallax', OrnayaParallax);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-hero"] && !Shopify.designMode) return;
  try {
    
  class OrnayaAboutHero extends HTMLElement {
    connectedCallback(){
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.bg = this.querySelector('[data-ah-bg]');
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, {passive:true});
      this.onScroll();
    }
    disconnectedCallback(){ window.removeEventListener('scroll', this.onScroll); }
    onScroll(){
      const r = this.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, -r.top / (r.height || 1)));
      if (this.bg) this.bg.style.transform = 'translate3d(0,'+(p*120)+'px,0) scale('+(1.04+p*0.1)+')';
    }
  }
  if(!customElements.get('ornaya-about-hero')) customElements.define('ornaya-about-hero', OrnayaAboutHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-jaipur"] && !Shopify.designMode) return;
  try {
    
  class OrnayaParallax extends HTMLElement {
    connectedCallback(){ if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; this.inner=this.querySelector('img,.ajp__ph')||this.firstElementChild; this.range=parseFloat(this.dataset.range||'40'); this.onScroll=this.onScroll.bind(this); window.addEventListener('scroll',this.onScroll,{passive:true}); this.onScroll(); }
    disconnectedCallback(){ window.removeEventListener('scroll',this.onScroll); }
    onScroll(){ const r=this.getBoundingClientRect(); const w=window.innerHeight; const p=(w-r.top)/(r.height+w); const y=(-this.range+p*this.range*2); if(this.inner) this.inner.style.transform='translate3d(0,'+y.toFixed(1)+'px,0)'; }
  }
  if(!customElements.get('ornaya-parallax')) customElements.define('ornaya-parallax', OrnayaParallax);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-manifesto"] && !Shopify.designMode) return;
  try {
    
  class OrnayaParallax extends HTMLElement {
    connectedCallback(){
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.inner = this.querySelector('img, .amf__ph, [class$="__img"]') || this.firstElementChild;
      this.range = parseFloat(this.dataset.range || '40');
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, {passive:true}); this.onScroll();
    }
    disconnectedCallback(){ window.removeEventListener('scroll', this.onScroll); }
    onScroll(){ const r=this.getBoundingClientRect(); const w=window.innerHeight; const p=(w-r.top)/(r.height+w); const y=(-this.range+p*this.range*2); if(this.inner) this.inner.style.transform='translate3d(0,'+y.toFixed(1)+'px,0)'; }
  }
  if(!customElements.get('ornaya-parallax')) customElements.define('ornaya-parallax', OrnayaParallax);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-packaging"] && !Shopify.designMode) return;
  try {
    
  class OrnayaAboutParallaxBg extends HTMLElement {
    connectedCallback(){ if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; this.bg=this.querySelector('[data-apk-bg]'); this.onScroll=this.onScroll.bind(this); window.addEventListener('scroll',this.onScroll,{passive:true}); this.onScroll(); }
    disconnectedCallback(){ window.removeEventListener('scroll',this.onScroll); }
    onScroll(){ const r=this.getBoundingClientRect(); const w=window.innerHeight; const p=(w-r.top)/(r.height+w); if(this.bg) this.bg.style.transform='translate3d(0,'+((p-0.5)*60).toFixed(1)+'px,0) scale(1.08)'; }
  }
  if(!customElements.get('ornaya-about-parallax-bg')) customElements.define('ornaya-about-parallax-bg', OrnayaAboutParallaxBg);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class OrnayaAnnouncement extends HTMLElement {
    connectedCallback() {
      this.messages = this.querySelectorAll('.ornaya-ann__msg');
      this.interval = parseInt(this.dataset.interval || '4200', 10);
      this.current = 0;
      if (this.messages.length <= 1) return;
      this.timer = setInterval(() => this.advance(), this.interval);
    }
    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }
    advance() {
      this.messages[this.current].classList.remove('is-active');
      this.current = (this.current + 1) % this.messages.length;
      this.messages[this.current].classList.add('is-active');
    }
  }
  if (!customElements.get('ornaya-announcement')) {
    customElements.define('ornaya-announcement', OrnayaAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestsellers"] && !Shopify.designMode) return;
  try {
    
  class OrnayaBsTabs extends HTMLElement {
    connectedCallback() {
      const tabsContainer = this.querySelector('[data-tabs-container]');
      const panels = Array.from(this.querySelectorAll('[data-panel]'));
      if (!tabsContainer || !panels.length) return;

      panels.forEach((panel, idx) => {
        const label = panel.dataset.label || ('Tab ' + (idx + 1));
        const tabId = 'bs-tab-' + idx;
        panel.dataset.tabId = tabId;
        if (idx === 0) panel.classList.add('is-active');

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bs-tab' + (idx === 0 ? ' is-active' : '');
        btn.dataset.tabId = tabId;
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
        btn.innerHTML = label + '<span class="bs-tab__underline"></span>';
        btn.addEventListener('click', () => this.activate(tabId));
        tabsContainer.appendChild(btn);
      });
    }
    activate(id) {
      this.querySelectorAll('.bs-tab').forEach((t) => {
        const active = t.dataset.tabId === id;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.querySelectorAll('[data-panel]').forEach((p) => p.classList.toggle('is-active', p.dataset.tabId === id));
    }
  }
  if (!customElements.get('ornaya-bs-tabs')) customElements.define('ornaya-bs-tabs', OrnayaBsTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["craft-journey"] && !Shopify.designMode) return;
  try {
    
  class OrnayaCraft extends HTMLElement {
    connectedCallback() {
      this.sticky   = this.querySelector('[data-sticky]');
      this.track    = this.querySelector('[data-track]');
      this.progress = this.querySelector('[data-progress]');
      this.steps    = parseInt(this.dataset.steps || '1', 10);

      // Respect reduced-motion: fall back to a simple vertical stack.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.setAttribute('data-static', '');
        return;
      }

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      // run after layout settles
      requestAnimationFrame(() => this.onScroll());
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
    onScroll() {
      if (!this.track || !this.sticky) return;
      const rect = this.getBoundingClientRect();
      const vh = window.innerHeight;
      const scrollable = this.offsetHeight - vh;

      let p, state;
      if (rect.top > 0) {
        state = 'top';   p = 0;                                   // not reached yet
      } else if (rect.bottom <= vh) {
        state = 'bottom'; p = 1;                                  // scrolled past
      } else {
        state = 'fixed';                                          // pinned
        p = scrollable > 0 ? Math.min(1, Math.max(0, -rect.top / scrollable)) : 0;
      }

      if (this.sticky.getAttribute('data-state') !== state) {
        this.sticky.setAttribute('data-state', state);
      }

      const distance = Math.max(0, (this.steps - 1) * 100);       // in vw
      this.track.style.transform = 'translate3d(' + (-p * distance).toFixed(3) + 'vw, 0, 0)';
      if (this.progress) this.progress.style.width = (p * 100).toFixed(2) + '%';
    }
  }
  if (!customElements.get('ornaya-craft')) customElements.define('ornaya-craft', OrnayaCraft);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  /* Parallax y-drift for inner image based on scroll progress through section */
  class OrnayaParallax extends HTMLElement {
    connectedCallback() {
      this.inner = this.querySelector('.coll-row__image-inner') || this.firstElementChild;
      this.range = parseFloat(this.dataset.range || '50');
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.onScroll();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
    onScroll() {
      const rect = this.getBoundingClientRect();
      const winH = window.innerHeight;
      const total = rect.height + winH;
      const p = (winH - rect.top) / total;          // 0 entering bottom → 1 leaving top
      const y = -this.range + (p * this.range * 2); // -range → +range
      if (this.inner) this.inner.style.transform = `translate3d(0, ${y.toFixed(1)}px, 0)`;
    }
  }
  if (!customElements.get('ornaya-parallax')) customElements.define('ornaya-parallax', OrnayaParallax);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  class OrnayaGallery extends HTMLElement {
    connectedCallback() {
      this.track  = this.querySelector('.pp-gallery__hero-track');
      this.hero   = this.querySelector('[data-hero]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.navs   = Array.from(this.querySelectorAll('[data-thumb]')); // thumbnails + dots
      this.index  = 0;

      // Click a thumbnail or a dot -> scroll the carousel to that image
      this.navs.forEach((b) => b.addEventListener('click', () => this.go(parseInt(b.dataset.thumb, 10))));
      // Desktop nicety: hovering a thumbnail also navigates
      this.querySelectorAll('.pp-gallery__thumb').forEach((b) =>
        b.addEventListener('mouseenter', () => this.go(parseInt(b.dataset.thumb, 10)))
      );

      // Keep dots/thumbs in sync while the user swipes/scrolls
      if (this.track) {
        let raf;
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => this.syncFromScroll());
        }, { passive: true });
      }

      // Desktop hover-to-zoom on the centred image
      if (this.hero) {
        this.hero.addEventListener('mousemove', (e) => this.zoom(e));
        this.hero.addEventListener('mouseleave', () => this.hero.removeAttribute('data-zoom'));
      }

      this.setActive(0);
    }
    go(i) {
      if (!this.track || !this.slides[i]) return;
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
      this.setActive(i);
    }
    syncFromScroll() {
      if (!this.track || !this.track.clientWidth) return;
      const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
      if (i !== this.index) this.setActive(i);
    }
    setActive(i) {
      this.index = i;
      this.slides.forEach((s, idx) => s.classList.toggle('is-active', idx === i));
      this.navs.forEach((t) => t.classList.toggle('is-active', parseInt(t.dataset.thumb, 10) === i));
    }
    zoom(e) {
      const active = this.slides[this.index] && this.slides[this.index].querySelector('.pp-gallery__img');
      if (!active) return;
      const rect = this.hero.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      this.hero.setAttribute('data-zoom', 'on');
      active.style.transformOrigin = `${x}% ${y}%`;
    }
  }
  if (!customElements.get('ornaya-gallery')) customElements.define('ornaya-gallery', OrnayaGallery);

  class OrnayaProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.variantInput = this.querySelector('[data-variant-id]');
      this.qtyEl    = this.querySelector('[data-qty]');
      this.qtyInput = this.querySelector('[data-qty-input]');
      this.qty = 1;

      this.querySelector('[data-qty-minus]')?.addEventListener('click', () => this.setQty(this.qty - 1));
      this.querySelector('[data-qty-plus]')?.addEventListener('click',  () => this.setQty(this.qty + 1));

      this.querySelectorAll('[data-option-button]').forEach((b) => {
        if (!b.disabled) b.addEventListener('click', () => this.selectPill(b));
      });
      this.querySelectorAll('[data-option-select]').forEach((sel) => {
        sel.addEventListener('change', () => this.selectDropdown(sel));
      });

      this.atbBtn    = this.querySelector('[data-atb-button]');
      this.buyNowBtn = this.querySelector('[data-buynow-button]');
      this.form?.addEventListener('submit', (e) => this.onSubmit(e));

      this.querySelectorAll('[data-share]').forEach((b) => {
        b.addEventListener('click', (e) => {
          e.preventDefault();
          const url = window.location.href;
          if (navigator.share) {
            navigator.share({ url, title: document.title }).catch(() => {});
          } else if (navigator.clipboard) {
            navigator.clipboard.writeText(url);
            const orig = b.innerHTML;
            b.textContent = 'Copied';
            setTimeout(() => { b.innerHTML = orig; }, 1600);
          }
        });
      });
    }
    setQty(n) {
      this.qty = Math.max(1, Math.min(9, n));
      this.qtyEl.textContent = this.qty;
      this.qtyInput.value = this.qty;
    }
    selectPill(btn) {
      const pos = parseInt(btn.dataset.optionPosition, 10);
      const val = btn.dataset.optionValue;
      this.querySelectorAll(`[data-option-button][data-option-position="${pos}"]`).forEach((b) => b.classList.toggle('is-selected', b === btn));
      const labelSpan = this.querySelector(`[data-option-value-${pos}]`);
      if (labelSpan) labelSpan.textContent = `· ${val}`;
      if (btn.dataset.variantId && this.variantInput) this.variantInput.value = btn.dataset.variantId;
    }
    selectDropdown(sel) {
      const pos = parseInt(sel.dataset.optionPosition, 10);
      const opt = sel.options[sel.selectedIndex];
      const val = opt.value;
      const labelSpan = this.querySelector(`[data-option-value-${pos}]`);
      if (labelSpan) labelSpan.textContent = `· ${val}`;
      if (opt.dataset.variantId && this.variantInput) this.variantInput.value = opt.dataset.variantId;
    }
    async onSubmit(e) {
      e.preventDefault();
      const isBuyNow = e.submitter && e.submitter.name === 'buy_now';
      this.addToCart(isBuyNow);
    }
    async addToCart(isBuyNow) {
      const btn = isBuyNow ? this.buyNowBtn : this.atbBtn;
      const otherBtn = isBuyNow ? this.atbBtn : this.buyNowBtn;
      if (!btn) return;
      btn.setAttribute('data-state', 'loading');
      if (otherBtn) otherBtn.disabled = true;
      try {
        const fd = new FormData(this.form);
        fd.delete('buy_now');
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const addRes = await fetch(root.replace(/\/?$/, '/') + 'cart/add.js', {
          method: 'POST', body: fd, headers: { 'Accept': 'application/json' }
        });
        if (!addRes.ok) throw new Error('add failed');
        if (isBuyNow) {
          window.location.href = root.replace(/\/?$/, '/') + 'checkout';
          return;
        }
        const cartRes = await fetch(root.replace(/\/?$/, '/') + 'cart.js', { headers: { 'Accept': 'application/json' } });
        const cart = await cartRes.json();
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'ornaya-product-form', data: { source: 'product-form-component', itemCount: cart.item_count, sections: {} } }
        }));
        // Open the cart drawer if the theme has one
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        btn.setAttribute('data-state', 'done');
        const label = btn.querySelector('.pp-info__atb-label');
        const original = label ? label.innerHTML : null;
        if (label) label.textContent = 'Added to Bag';
        setTimeout(() => {
          btn.removeAttribute('data-state');
          if (label && original) label.innerHTML = original;
          if (otherBtn) otherBtn.disabled = false;
        }, 1800);
      } catch (err) {
        btn.removeAttribute('data-state');
        if (otherBtn) otherBtn.disabled = false;
      }
    }
  }
  if (!customElements.get('ornaya-product-form')) customElements.define('ornaya-product-form', OrnayaProductForm);

  class OrnayaBuybar extends HTMLElement {
    connectedCallback() {
      const anchor = document.getElementById('buy-anchor');
      if (!anchor) return;
      const obs = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) { this.removeAttribute('data-open'); this.hidden = true; }
        else { this.hidden = false; requestAnimationFrame(() => this.setAttribute('data-open', '')); }
      }, { threshold: 0 });
      obs.observe(anchor);
      this._obs = obs;

      // Add-to-Bag in the sticky bar adds the current selection to cart directly
      this.cta = this.querySelector('[data-buybar-add]');
      this.cta?.addEventListener('click', () => {
        const form = document.querySelector('ornaya-product-form');
        if (!form || typeof form.addToCart !== 'function') return;
        form.addToCart(false);
        const original = this.cta.textContent;
        this.cta.textContent = 'Added';
        this.cta.disabled = true;
        setTimeout(() => { this.cta.textContent = original; this.cta.disabled = false; }, 1800);
      });
    }
    disconnectedCallback() { this._obs?.disconnect(); }
  }
  if (!customElements.get('ornaya-buybar')) customElements.define('ornaya-buybar', OrnayaBuybar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  class OrnayaNewsletter extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-form]');
      this.submit = this.querySelector('[data-submit]');
      this.idleEl = this.querySelector('[data-state="idle"]');
      this.subEl  = this.querySelector('[data-state="submitting"]');
      this.success = this.querySelector('[data-success]');

      this.form.addEventListener('submit', (e) => {
        // Allow the actual Shopify submit; provide instant UI feedback
        this.idleEl.hidden = true;
        this.subEl.hidden = false;
        this.submit.disabled = true;
        // After 700ms show the success state — actual Shopify success page will replace this
        setTimeout(() => {
          this.form.hidden = true;
          this.success.hidden = false;
          requestAnimationFrame(() => this.success.classList.add('is-visible'));
        }, 700);
      });
    }
  }
  if (!customElements.get('ornaya-newsletter')) customElements.define('ornaya-newsletter', OrnayaNewsletter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ornaya-hero"] && !Shopify.designMode) return;
  try {
    
  class OrnayaHero extends HTMLElement {
    connectedCallback() {
      this.bg      = this.querySelector('.hero__bg');
      this.overlay = this.querySelector('[data-hero-overlay]');
      this.video   = this.querySelector('[data-hero-video]');
      if (this.video) {
        this.video.addEventListener('canplay', () => this.video.setAttribute('data-ready', ''));
        this.video.addEventListener('error',   () => this.video.removeAttribute('data-ready'));
      }
      this.section = this.closest('.hero');
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }
    disconnectedCallback() { window.removeEventListener('scroll', this.onScroll); }
    onScroll() {
      if (!this.section) return;
      const rect = this.section.getBoundingClientRect();
      const heroH = rect.height || window.innerHeight;
      const p = Math.min(1, Math.max(0, -rect.top / heroH));
      const scale = 1.06 + (0.09 * p);
      const y     = 80 * p;
      this.bg.style.transform = `translate3d(0, ${y}px, 0) scale(${scale})`;
      if (this.overlay) this.overlay.style.opacity = (0.35 + (0.35 * p)).toFixed(3);
    }
  }
  if (!customElements.get('ornaya-hero')) customElements.define('ornaya-hero', OrnayaHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof"] && !Shopify.designMode) return;
  try {
    
  class OrnayaTestimonials extends HTMLElement {
    connectedCallback() {
      const stage = this.querySelector('[data-stage]');
      const dotsContainer = this.querySelector('[data-dots]');
      this.slides = Array.from(this.querySelectorAll('.testimonial'));
      this.interval = parseInt(this.dataset.interval || '6500', 10);
      this.current = 0;
      if (!this.slides.length) return;

      this.slides[0].classList.add('is-active');

      this.slides.forEach((_, idx) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'social-section__dot' + (idx === 0 ? ' is-active' : '');
        dot.dataset.dot = idx;
        dot.setAttribute('aria-label', 'Show testimonial ' + (idx + 1));
        dot.addEventListener('click', () => this.go(idx, true));
        dotsContainer.appendChild(dot);
      });
      this.dots = Array.from(this.querySelectorAll('.social-section__dot'));

      if (this.slides.length > 1) {
        this.timer = setInterval(() => this.go((this.current + 1) % this.slides.length), this.interval);
      }
    }
    disconnectedCallback() { if (this.timer) clearInterval(this.timer); }
    go(i, fromUser) {
      if (i === this.current || i >= this.slides.length) return;
      this.slides[this.current].classList.remove('is-active');
      if (this.dots[this.current]) this.dots[this.current].classList.remove('is-active');
      this.current = i;
      this.slides[i].classList.add('is-active');
      if (this.dots[i]) this.dots[i].classList.add('is-active');
      if (fromUser && this.slides.length > 1) {
        clearInterval(this.timer);
        this.timer = setInterval(() => this.go((this.current + 1) % this.slides.length), this.interval);
      }
    }
  }
  if (!customElements.get('ornaya-testimonials')) customElements.define('ornaya-testimonials', OrnayaTestimonials);

  class OrnayaPressMarquee extends HTMLElement {
    connectedCallback() {
      const content = this.querySelector('[data-press-content]');
      const clone = this.querySelector('[data-press-clone]');
      if (content && clone) clone.innerHTML = content.innerHTML;
    }
  }
  if (!customElements.get('ornaya-press-marquee')) customElements.define('ornaya-press-marquee', OrnayaPressMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-marquee"] && !Shopify.designMode) return;
  try {
    
  class OrnayaMarquee extends HTMLElement {
    connectedCallback() {
      const content = this.querySelector('[data-marquee-content]');
      const clone = this.querySelector('[data-marquee-clone]');
      if (content && clone) clone.innerHTML = content.innerHTML;
    }
  }
  if (!customElements.get('ornaya-marquee')) customElements.define('ornaya-marquee', OrnayaMarquee);

  } catch(e) { console.error(e); }
})();
})();
